const KEY = "bs_recently_viewed";

function money(cents) {
  try { return "$" + (cents / 100).toFixed(2); } catch (e) { return ""; }
}

function card(p) {
  const img = p.featured_image || (p.images && p.images[0]) || "";
  const variant = (p.variants || []).find((v) => v.available) || (p.variants || [])[0];
  const available = p.available && variant;
  const imgTag = img
    ? `<div class="bs-rv-img"><img src="${img}" alt="" loading="lazy"></div>`
    : `<div class="bs-rv-img"></div>`;
  const atc = available
    ? `<form action="/cart/add" method="post" class="bs-atc-form"><input type="hidden" name="id" value="${variant.id}"><button type="submit" class="bs-atc">Add to cart</button></form>`
    : `<div class="bs-atc-form"><button class="bs-atc bs-atc--out" disabled>Sold out</button></div>`;
  return `<div class="bs-rv-card"><a class="bs-rv-link" href="${p.url}">${imgTag}<div class="bs-rv-title">${p.title}</div><div class="bs-rv-price">${money(p.price)}</div></a>${atc}</div>`;
}

class RecentlyViewed extends HTMLElement {
  async connectedCallback() {
    const current = this.dataset.current || "";
    const limit = parseInt(this.dataset.limit, 10) || 5;

    let list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) { list = []; }
    if (!Array.isArray(list)) list = [];

    // products to show = previously viewed (before recording the current one)
    const others = list.filter((h) => h && h !== current).slice(0, limit);

    // record the current product at the front
    if (current) {
      const next = [current, ...list.filter((h) => h !== current)].slice(0, 12);
      try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) {}
    }

    if (!others.length) return;
    const grid = this.querySelector("[data-rv-grid]");
    if (!grid) return;

    const data = await Promise.all(
      others.map((h) => fetch(`/products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)),
    );
    const items = data.filter(Boolean);
    if (!items.length) return;

    grid.innerHTML = items.map(card).join("");
    this.hidden = false;
  }
}

if (!customElements.get("recently-viewed")) {
  customElements.define("recently-viewed", RecentlyViewed);
}
